import { render, staticRenderFns } from "./KimsaTextareaField.vue?vue&type=template&id=7f04efc4&scoped=true"
import script from "./KimsaTextareaField.vue?vue&type=script&lang=js"
export * from "./KimsaTextareaField.vue?vue&type=script&lang=js"
import style0 from "./KimsaTextareaField.vue?vue&type=style&index=0&id=7f04efc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f04efc4",
  null
  
)

export default component.exports